var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2994",
    "data-name": "Group 2994",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_822",
    "data-name": "Rectangle 822",
    width: 24,
    height: 24,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2993",
    "data-name": "Group 2993",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M113.336,99.424a5.049,5.049,0,0,1,2.053-1.929,6.107,6.107,0,0,1,3.289-.613,8.319,8.319,0,0,1,1.826.305,4.483,4.483,0,0,1,2.988,2.8,9,9,0,0,1,.59,2.934c.137,3.4.024,6.806.064,10.208,0,.247-.088.327-.326.326-1.476-.006-2.951-.009-4.427,0-.307,0-.354-.144-.354-.4q.007-3.733,0-7.467a9.6,9.6,0,0,0-.19-2.462,2.252,2.252,0,0,0-2.646-1.793c-1.885.115-2.387,1.414-2.573,2.64a11.076,11.076,0,0,0-.076,1.648q-.007,3.689,0,7.378c0,.462,0,.462-.449.462-1.426,0-2.853-.006-4.279.006-.281,0-.371-.079-.371-.366q.011-7.747,0-15.495c0-.262.069-.363.347-.361q2.1.017,4.191,0c.285,0,.352.111.346.367-.013.57,0,1.14,0,1.81",
    transform: "translate(-99.902 -89.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M9.769,109.878q0,3.836,0,7.673c0,.412,0,.414-.4.414-1.446,0-2.892-.006-4.338.005-.268,0-.363-.08-.363-.351q.008-7.761,0-15.523c0-.248.073-.349.338-.347q2.213.015,4.427,0c.289,0,.341.116.34.368q-.009,3.881,0,7.761",
    transform: "translate(-4.3 -93.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M2.915,5.883A2.924,2.924,0,0,1,0,2.916a2.937,2.937,0,0,1,5.873.036A2.926,2.926,0,0,1,2.915,5.883",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon_linkedin.7142b922fcbba127fdf3cd110593ad52.svg";
export { ForwardRef as ReactComponent };